import { render, staticRenderFns } from "./DashboardSkeleton.vue?vue&type=template&id=59a70b11&scoped=true"
import script from "./DashboardSkeleton.vue?vue&type=script&lang=js"
export * from "./DashboardSkeleton.vue?vue&type=script&lang=js"
import style0 from "./DashboardSkeleton.vue?vue&type=style&index=0&id=59a70b11&prod&scoped=true&lang=css"
import style1 from "./DashboardSkeleton.vue?vue&type=style&index=1&id=59a70b11&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a70b11",
  null
  
)

export default component.exports